<template>
  <Loader :promise="promise" theme="default" class="task-reference-residential">
    <Residential v-if="item" :value="item.reference" theme="list" />
  </Loader>
</template>

<script>
import Api from '@/api/Residential'
import Residential from '@/components/Residential/Card'

export default {
  props: {
    value: String,
  },
  watch: {
    value: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      item: null,
    }
  },
  methods: {
    fetch() {
      this.promise = Api.get({ id: this.value }, { query: 'TaskReferenceShop' }).then(item => (this.item = item))
    },
  },
  components: {
    Residential,
  },
}
</script>
